import { render, staticRenderFns } from "./TopSpenderCampaign.vue?vue&type=template&id=ec55364e"
import script from "./TopSpenderCampaign.vue?vue&type=script&lang=js"
export * from "./TopSpenderCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports